import React, {useEffect, useState} from "react";


const PieChart = ({children, ...props}) => {
    const [number, setNumber] = useState(0); // State for the number
    useEffect(() => {
        setNumber(0)
        const interval = setInterval(() => {
            setNumber(prevNumber => {
                if (prevNumber < props["percent"]) {
                    return prevNumber + 1; // Increment number from 1 to 100
                } else {
                    clearInterval(interval); // Stop the interval when number reaches 100
                    return props["percent"]; // Return the current number as 100
                }
            });
        }, 5);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, [props["percent"]]); // Run only on component mount

    return (
        <div className={`flex items-center justify-center w-full h-full rounded-full transition-all duration-700 transition-transform duration-500 transform`} style={{backgroundImage: `conic-gradient(${props["first_color"]} ${number+"%"}, ${props["second_color"]} ${number+"%"})`}}>
            <div className="flex flex-col justify-center items-center w-[70%] h-[70%] rounded-full bg-[#001037]">
                {children}
            </div>
        </div>
    );
};

export default PieChart;